import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';

export const productApi = createApi({
  reducerPath: 'productApi',
  baseQuery: createAuthBaseQuery(),
  tagTypes: ['Product'],
  endpoints: (builder) => ({
    getProducts: builder.query<unknown[], void>({
      query: () => 'products',
      providesTags: ['Product'],
    }),
    getProduct: builder.query<unknown, string>({
      query: (id) => `products/${id}`,
      providesTags: ['Product'],
    }),
    createProduct: builder.mutation<unknown, Record<string, unknown>>({
      query: (body) => ({ url: 'products', method: 'POST', body }),
      invalidatesTags: ['Product'],
    }),
    updateProduct: builder.mutation<unknown, { id: string; data: Record<string, unknown> }>({
      query: ({ id, data }) => ({ url: `products/${id}`, method: 'PUT', body: data }),
      invalidatesTags: ['Product'],
    }),
    deleteProduct: builder.mutation<void, string>({
      query: (id) => ({ url: `products/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Product'],
    }),
  }),
});

export const {
  useGetProductsQuery,
  useGetProductQuery,
  useCreateProductMutation,
  useUpdateProductMutation,
  useDeleteProductMutation,
} = productApi;
